import PageChrome from "@/layouts/PageChrome.jsx";
import AppVersionsPanel from "@/components/super-admin/AppVersions.jsx";

/*
 * Desktop app versions — a PLATFORM page, not an organization one.
 *
 * It used to be the fifth tab inside Super Admin, next to Organizations, Users,
 * Analytics and Packages. Those four are all "one organization at a time"; a
 * published build is the opposite — every organization's agents poll
 * /api/app-version/latest and update from whatever is newest here. Keeping it
 * among per-organization tabs suggested a scope it never had, so it is its own
 * entry in the Platform menu.
 *
 * The panel component is unchanged and still lives under components/super-admin,
 * because that is who may use it: the route carries the same superAdmin gate the
 * Super Admin page does.
 */
export default function AppVersions() {
    return (
        <>
            <PageChrome breadcrumb={["App Versions"]} title="App Versions" />

            <main className="mx-auto flex w-full max-w-[1680px] flex-col gap-5 p-4 lg:p-5">
                <div>
                    <h1 className="text-[22px] font-semibold tracking-tight">App Versions</h1>
                    <p className="mt-0.5 text-[13px] text-slate-500 dark:text-slate-400">
                        The desktop builds every organization's agents update themselves from.
                        Publishing one makes it the latest for that platform and architecture.
                    </p>
                </div>

                <AppVersionsPanel />
            </main>
        </>
    );
}
